import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBell = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "Property 1=Variant3",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M13.791 4.25345L13.7898 4.25309M13.7898 4.25309C13.2236 4.08853 12.6227 4 12 4C11.4186 4 10.8561 4.07719 10.3232 4.22139C10.2853 4.23164 10.2476 4.24224 10.21 4.25316M13.7898 4.25309C16.1994 4.9535 17.9784 7.03134 18.1164 9.52367M10.21 4.25316C7.70052 4.98271 5.875 7.20622 5.875 9.83597V13.2673C5.875 13.9504 5 14.3387 5 15.166C5 15.6265 5.39176 16 5.875 16L18.125 15.9999C18.6083 15.9999 19 15.6266 19 15.1662M10.21 4.25316L10.209 4.25345M19 15.1662C19 14.5847 18.5534 14.2107 18.2984 13.7974M19 15.1662C19 14.5752 18.5534 14.208 18.2984 13.7974M18.125 13.2671V9.83598C18.125 9.8176 18.1249 9.79923 18.1247 9.78088C18.1239 9.69463 18.1212 9.60883 18.1164 9.52367M18.125 13.2671C18.125 13.4607 18.1964 13.6322 18.2984 13.7974M18.125 13.2671C18.125 13.4622 18.1964 13.6333 18.2984 13.7974M18.1164 9.52367C18.114 9.48202 18.1112 9.44052 18.1079 9.3992M10 19C10.2076 19.5158 11.0237 20.5 12 20.5C12.9763 20.5 13.7924 19.5158 14 19",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})]
});
const ForwardRef = forwardRef(SvgBell);
export default ForwardRef;
